import Link from 'next/link'

import Button from '@/components/base/button'
import Typography from '@/components/base/typography'
import TypographyMask from '@/components/base/typography-mask'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

const ButtonSticky = () => {
  const { strings } = useStore()
  const { links } = strings || {}

  return (
    <Button
      theme="light"
      asChild
      className={cn(
        'z-sticky sticky bottom-0 flex justify-center drop-shadow-[0_20px_20px_rgba(0,0,0,0.25)] md:hidden',
        'h-[5rem] rounded-none before:rounded-none after:rounded-none',
        '[.header-contained_&]:text-light [.header-contained_&]:before:bg-dark',
        '[.page-transition_&]:text-light [.page-transition_&]:before:bg-dark'
      )}
    >
      <Link href={links?.book.url} target={links?.book.target} scroll={false}>
        <TypographyMask>
          <Typography variant="label">{links?.book.title}</Typography>
        </TypographyMask>
      </Link>
    </Button>
  )
}

export default ButtonSticky
